import { Arrays, Calculation, CostAccountingDimensionScope } from "@salaxy/core";

import { SessionService} from "../../services";

import { CostAccountingController } from "./CostAccountingController";

/**
 * Handles the user interaction for entering cost accounting data for the calculation.
 */
export class CalcCostAccountingController extends CostAccountingController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["SessionService"];

  /** The calculation*/
  public calc: Calculation;

  /**
   * Creates a new CalcCostAccountingController
   * @ignore
   */
  constructor(
    sessionService: SessionService
  ) {
    super(sessionService);
  }

  /**
   * Implement IController
   */
  public $onInit() {
   this.scope = CostAccountingDimensionScope.Calculation;
   super.$onInit();
  }

  /**
   * Returns true if the current calculation is read only.
   */
   public get isReadOnly(): boolean {
    if (this.readOnly === true || this.readOnly === false) {
      return this.readOnly;
    }
    return this.calc.isReadOnly;
  }

  // TO BE REMOVED

  /** Returns the cost accounting model type */
  public get isLegacy(): boolean {
    //backward compat.
    if (this.calc.usecase?.uri === "/UsecaseDefinition/FI53POYS0025543933/costcenter-percentages") {
      return true;
    }
    return false;
  }

  /** Returns total cost center percentage */
  public getLegacySum(): number {
    if (this.isLegacy) {
      return Arrays.sum(this.calc.usecase?.data?.dimensions?.costCenter ?? [], (x: any) => x.percent ?? 0);
    }
    return 0;
  }

  /** Returns current costCenter. */
  public get costCenter() {
    if (this.isLegacy) {
      if (!this.calc.usecase) {
        this.calc.usecase = {};
      }
      if (!this.calc.usecase.data) {
        this.calc.usecase.data = {};
      }
      if (!this.calc.usecase.data.dimensions) {
        this.calc.usecase.data.dimensions = {};
      }
      if (!this.calc.usecase.data.dimensions.costCenter) {
        this.calc.usecase.data.dimensions.costCenter = [];
      }
    }
    return this.calc.usecase?.data?.dimensions?.costCenter;
  }
}
